/* Manresa Shopify theme glue: replaces Smootify runtime with native Shopify AJAX APIs. */
(function () {
  'use strict';
  const routes = (window.theme && window.theme.routes) || { cart_add: '/cart/add', cart_change: '/cart/change', cart: '/cart', root: '/' };

  function money(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    const v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(cents / 100).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return v.replace('.', ',');
      return Number(v).toLocaleString('en-US', { minimumFractionDigits: 2 });
    });
  }

  /* ---------------- cart drawer refresh ---------------- */
  async function refreshCart() {
    const url = (routes.root || '/').replace(/\/?$/, '/') + '?sections=header';
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    const data = await res.json();
    const html = data && data.header;
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-scope]');
    const scope = document.querySelector('[data-cart-scope]');
    if (!fresh || !scope) return;
    const freshBlock = fresh.querySelector('.g_formblock');
    const block = scope.querySelector('.g_formblock');
    if (freshBlock && block) block.innerHTML = freshBlock.innerHTML;
    const count = fresh.querySelector('[data-cart-count]');
    scope.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count ? count.textContent : '0'; });
    scope.setAttribute('data-cart-empty', fresh.getAttribute('data-cart-empty'));
  }

  async function changeLine(line, quantity) {
    await fetch(routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });
    await refreshCart();
  }

  /* ---------------- add to cart ---------------- */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    form.classList.add('is-loading');
    try {
      const res = await fetch(routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const json = await res.json();
      if (!res.ok) { alert(json.description || json.message || 'Could not add to cart'); return; }
      await refreshCart();
      // The Webflow cart drawer script listens for this (kept from the Smootify build) and opens the drawer.
      document.dispatchEvent(new CustomEvent('smootify:added_to_cart', { detail: { goToCheckout: false } }));
    } catch (err) {
      form.removeAttribute('data-ajax-add');
      form.submit();
    } finally {
      form.classList.remove('is-loading');
    }
  });

  /* ---------------- quantity +/- and remove ---------------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product_count_button[data-action]');
    if (btn) {
      const wrap = btn.closest('[data-qty]');
      const input = wrap && wrap.querySelector('input');
      if (!input) return;
      e.preventDefault();
      const min = btn.closest('[data-cart-scope]') ? 1 : Number(input.min || 1);
      let v = Number(input.value || 1) + (btn.dataset.action === 'plus' ? 1 : -1);
      if (v < min) v = min;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const rm = e.target.closest('[data-cart-scope] [data-cart-remove]');
    if (rm) {
      const item = rm.closest('[data-line]');
      if (!item) return;
      e.preventDefault();
      changeLine(item.dataset.line, 0);
    }
  });
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (input.matches('[data-cart-scope] input[name="updates[]"]')) {
      changeLine(input.dataset.line, Math.max(0, Number(input.value)));
    }
    if (input.matches('[data-product-root] input[name="quantity"]')) updateProduct(input.closest('[data-product-root]'));
    if (input.matches('[data-product-root] [data-option-select]')) updateProduct(input.closest('[data-product-root]'), true);
  });

  /* ---------------- product variants ---------------- */
  function productData(root) {
    if (root._product) return root._product;
    const el = root.querySelector('[data-product-json]');
    root._product = el ? JSON.parse(el.textContent) : null;
    return root._product;
  }
  function updateProduct(root, optionChanged) {
    if (!root) return;
    const product = productData(root);
    if (!product) return;
    const selects = Array.from(root.querySelectorAll('[data-option-select]'));
    const idInput = root.querySelector('[data-variant-id]');
    let variant = product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0];
    if (selects.length) {
      const values = selects.map(function (s) { return s.value; });
      variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === values[i]; }); });
    }
    const btn = root.querySelector('[data-add-button]');
    const label = root.querySelector('[data-add-label]');
    const total = root.querySelector('[data-total-price]');
    const qty = Number((root.querySelector('input[name="quantity"]') || {}).value || 1);
    if (!variant) {
      if (btn) btn.dataset.disabled = 'true';
      if (label) label.textContent = 'Unavailable';
      return;
    }
    idInput.value = variant.id;
    if (total) total.textContent = money(variant.price * qty);
    if (btn) btn.dataset.disabled = variant.available ? '' : 'true';
    if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
    if (optionChanged) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      const img = variant.featured_image;
      root.variant = img ? { image: { url: img.src, altText: img.alt || '' } } : null;
      // The Webflow thumbnail script listens for this event on smootify-product.
      root.dispatchEvent(new CustomEvent('changeVariant', { detail: root.variant }));
    }
  }
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    const product = productData(root);
    const idInput = root.querySelector('[data-variant-id]');
    if (product && idInput) {
      const v = product.variants.find(function (x) { return String(x.id) === String(idInput.value); });
      if (v && v.featured_image) root.variant = { image: { url: v.featured_image.src, altText: v.featured_image.alt || '' } };
    }
    updateProduct(root);
  });

  /* ---------------- product recommendations ---------------- */
  document.querySelectorAll('[data-recommendations-url]').forEach(async function (el) {
    try {
      const res = await fetch(el.dataset.recommendationsUrl);
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const fresh = doc.querySelector('[data-recommendations-url]');
      if (!fresh || !fresh.innerHTML.trim()) { const s = el.closest('section'); if (s) s.style.display = 'none'; return; }
      el.innerHTML = fresh.innerHTML;
      const swiperEl = el.closest('[data-swiper]');
      if (swiperEl && window.Swiper && !swiperEl.dataset.scriptInitialized) {
        swiperEl.dataset.scriptInitialized = 'true';
        const section = swiperEl.closest('section');
        // Unwrap so slides are direct children of .swiper-wrapper
        while (el.firstChild) el.parentNode.insertBefore(el.firstChild, el);
        el.remove();
        new Swiper(swiperEl, {
          slidesPerView: 'auto', speed: 600, slideActiveClass: 'is-active',
          navigation: { nextEl: section && section.querySelector("[data-swiper-arrow$='-next']"), prevEl: section && section.querySelector("[data-swiper-arrow$='-prev']") }
        });
      }
    } catch (e) {}
  });

  /* ---------------- article table of contents ---------------- */
  document.querySelectorAll('[data-article-toc]').forEach(function (toc) {
    const content = document.querySelector('[data-article-content]');
    if (!content) return;
    const cls = toc.dataset.chapterClass || 'article_chapter';
    content.querySelectorAll('h2').forEach(function (h, i) {
      if (!h.id) h.id = 'chapter-' + (i + 1);
      const a = document.createElement('a');
      a.className = cls; a.href = '#' + h.id; a.textContent = h.textContent;
      toc.appendChild(a);
    });
    if (!toc.children.length) toc.style.display = 'none';
  });
})();
